import system from "./systemApis";
import policy from "./policyApis";
import order from "./orderApis";
import bill from "./billApis";
import base from "./baseApis";
import tour from "./tourApis";
import flight from "./flightApis";
import message from "./messageApi";
import tourpolicy from "./tourPolicyApi";
import hotelpolicy from "./hotelPolicyApi";
import trainpolicy from "./trainPolicyApi";
import flightpolicy from "./flightPolicyApi";
import btrip from "./btripApi";
import train from "./trainApis";
import hotel from "./hotelApi";
import work from "./workApis";
import insurancepolicy from "./insurancePolicyApis";
import chargepolicy from "./chargepolicyapi";
import side from "./sideapi";
import trade from "./tradeApis";
import logs from "./logsApis";
import storage from "./storageApis";
import adapter from "./adapterApis";
import huilianyi from "./huilianyiapi";
export default {
  system,
  policy,
  order,
  bill,
  base,
  tour,
  flight,
  message,
  flightpolicy,
  hotelpolicy,
  trainpolicy,
  tourpolicy,
  btrip,
  train,
  hotel,
  work,
  side,
  insurancepolicy,
  chargepolicy,
  trade,
  logs,
  storage,
  adapter,
  huilianyi,
  getService(serviceCode) {
    if (serviceCode != undefined) {
      return this[serviceCode.toLowerCase().replace("service", "")];
    }
  },
};



// WEBPACK FOOTER //
// ./src/apis/index.js